(function () {
  'use strict';
  if (window.clCollectionPaginationReady) return;
  window.clCollectionPaginationReady = true;

  function init(root) {
    var meta = root.querySelector('[data-cl-pagination]');
    var grid = root.querySelector('.cl-granell-shop__grid');
    if (!meta || !grid || root.dataset.clPaginationReady) return;
    root.dataset.clPaginationReady = 'true';

    var startPage = Number(meta.dataset.clPage) || 1;
    var totalPages = Number(meta.dataset.clPages) || 1;
    var total = Number(meta.dataset.clTotal) || 0;
    var pageParam = meta.dataset.clPageParam || 'page';
    var pages = new Map();
    var more = root.querySelector('[data-load-more]');
    var wrap = root.querySelector('.cl-granell-shop__more-wrap');
    var status = root.querySelector('[data-results-status]');
    var empty = root.querySelector('.cl-granell-shop__empty');
    var filters = Array.from(root.querySelectorAll('[data-filter], [data-capsule-filter]'));
    var activeFilter = 'all';
    var limit = 20;
    var busy = false;
    var scopeStart = startPage;
    var baseURL = new URL(window.location.href);
    baseURL.hash = '';
    baseURL.searchParams.delete('section_id');

    function pageURL(page) {
      var url = new URL(baseURL.href);
      if (page === 1) url.searchParams.delete(pageParam);
      else url.searchParams.set(pageParam, String(page));
      return url;
    }

    // Keep existing filters/sorting/preview parameters when returning to page one.
    var first = root.querySelector('[data-cl-first-page]');
    if (first) first.href = pageURL(1).href;
    pages.set(startPage, Array.from(grid.querySelectorAll('.cl-granell-shop__item')));

    function matchingItems() {
      var items = [];
      Array.from(pages.keys()).sort(function (a, b) { return a - b; }).forEach(function (page) {
        if (page < scopeStart) return;
        pages.get(page).forEach(function (item) {
          var groups = (item.dataset.capsuleGroups || '').trim().split(/\s+/);
          if (activeFilter === 'all' || item.dataset.format === activeFilter || groups.indexOf(activeFilter) !== -1) {
            items.push({ item: item, page: page });
          }
        });
      });
      return items;
    }

    function nextMissingPage() {
      for (var page = scopeStart; page <= totalPages; page++) {
        if (!pages.has(page)) return page;
      }
      return null;
    }

    function contiguousCount() {
      var count = 0;
      for (var page = scopeStart; page <= totalPages && pages.has(page); page++) {
        count += pages.get(page).length;
      }
      return count;
    }

    function render() {
      var matches = matchingItems();
      // All nodes use server order even when filtering starts from page 2 or later.
      var fragment = document.createDocumentFragment();
      Array.from(pages.keys()).sort(function (a, b) { return a - b; }).forEach(function (page) {
        pages.get(page).forEach(function (item) { item.hidden = true; fragment.appendChild(item); });
      });
      grid.appendChild(fragment);
      matches.slice(0, limit).forEach(function (entry) { entry.item.hidden = false; });
      var missing = nextMissingPage();
      var count = activeFilter === 'all' ? Math.max(0, total - (scopeStart - 1) * 20) : matches.length;
      if (status) {
        status.textContent = 'Mostrando ' + Math.min(limit, matches.length) + ' de ' + count + ' productos';
        if (activeFilter !== 'all' && missing) status.textContent += ' encontrados; buscando en toda la colección…';
      }
      if (empty) empty.hidden = matches.length !== 0 || missing !== null || busy;
      var nextPage = matches[limit] ? matches[limit].page : missing;
      if (wrap) wrap.hidden = nextPage === null || nextPage === undefined;
      if (more) {
        if (nextPage) more.href = pageURL(nextPage).href;
        // A buffered card may share the current server page after applying filters.
        more.removeAttribute('rel');
        more.textContent = busy ? 'Cargando…' : 'Ver más productos';
        more.setAttribute('aria-disabled', busy ? 'true' : 'false');
      }
    }

    async function fetchPage(page) {
      if (pages.has(page)) return;
      var url = pageURL(page);
      // Shopify renders only this section; the public links remain normal page URLs.
      url.searchParams.set('section_id', meta.dataset.clSection);
      var controller = new AbortController();
      var timer = window.setTimeout(function () { controller.abort(); }, 20000);
      try {
        var response = await fetch(url.href, { credentials: 'same-origin', signal: controller.signal });
        if (!response.ok) throw new Error('No se pudo cargar la página');
        var html = await response.text();
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var incomingRoot = doc.getElementById(root.id);
        var incomingMeta = incomingRoot && incomingRoot.querySelector('[data-cl-pagination]');
        if (!incomingMeta || Number(incomingMeta.dataset.clPage) !== page) throw new Error('Página inesperada');
        var incoming = Array.from(incomingRoot.querySelectorAll('.cl-granell-shop__grid > .cl-granell-shop__item'));
        var updatedTotal = Number(incomingMeta.dataset.clTotal);
        var updatedPages = Number(incomingMeta.dataset.clPages);
        if (!incoming.length && page <= updatedPages && updatedTotal > 0) throw new Error('Página incompleta');
        total = updatedTotal;
        totalPages = updatedPages;
        pages.set(page, incoming.map(function (item) { return document.importNode(item, true); }));
      } finally {
        window.clearTimeout(timer);
      }
    }

    async function update(loadEverything) {
      if (busy) return;
      busy = true;
      root.setAttribute('aria-busy', 'true');
      filters.forEach(function (button) { button.disabled = true; });
      render();
      var failed = false;
      try {
        var next = nextMissingPage();
        while (next !== null && (loadEverything || contiguousCount() < limit)) {
          await fetchPage(next);
          render();
          next = nextMissingPage();
        }
      } catch (error) {
        failed = true;
      } finally {
        busy = false;
        filters.forEach(function (button) { button.disabled = false; });
        root.removeAttribute('aria-busy');
        render();
        if (failed) {
          if (status) status.textContent = 'No pudimos cargar todos los productos. Pulsa Ver más para reintentar.';
          if (empty) empty.hidden = true;
        }
      }
    }

    if (more) more.addEventListener('click', function (event) {
      if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey || event.button !== 0) return;
      event.preventDefault();
      if (busy) return;
      // A failed request must retry the same target, not skip another batch.
      if (matchingItems().length >= limit) limit += 12;
      update(activeFilter !== 'all');
    });

    filters.forEach(function (button) {
      button.addEventListener('click', function () {
        if (busy) return;
        activeFilter = button.dataset.filter || button.dataset.capsuleFilter || 'all';
        scopeStart = 1;
        limit = 20;
        filters.forEach(function (other) {
          var selected = other === button;
          other.classList.toggle('is-active', selected);
          other.setAttribute('aria-pressed', selected ? 'true' : 'false');
        });
        update(activeFilter !== 'all');
      });
    });

    render();
  }

  function initAll(container) {
    container.querySelectorAll('[data-cl-product-list]').forEach(init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  else initAll(document);
  document.addEventListener('shopify:section:load', function (event) { initAll(event.target); });
})();
